/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { UserSettingEntity } from '@axiom/domain';
/**
 * Response projection of the UserSetting entity. Extends UserSettingEntity
 * (inherits `static key = 'UserSetting'`), so this projection and the full
 * UserSetting entity merge into the same normalized cache record.
 * dark-roast DTO: UserSettingResponseDto
 */
export class UpdateUserSettingResponseEntity extends UserSettingEntity {
}